/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import styles.
 */
import '@material/toolbar/mdc-toolbar.scss';

/**
 * Import local dependencies.
 */
import './index.scss';

/**
 * Create the component.
 */
export default class Toolbar extends Component {
  render({
           'class': className,
           children,
           black,
           fixed,
           ...props
         }, state, context) {
    const classes = classnames('mdc-toolbar',
    {
      'mdc-toolbar__black': black
    },
    {
      'mdc-toolbar--fixed': fixed
    }, className);
    return (
      <header class={classes} {...props}>{children}</header>
    );
  }
}



// WEBPACK FOOTER //
// ../q-mdc/elements/material-toolbar/index.js